var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgC(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 288,
    viewBox: "0 0 256 288",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.987 85.672C255.985 80.829 254.95 76.55 252.858 72.878C250.803 69.266 247.724 66.24 243.596 63.846C209.515 44.176 175.401 24.566 141.332 4.876C132.147 -0.430996 123.241 -0.237996 114.124 5.146C100.559 13.154 32.643 52.102 12.405 63.835C4.071 68.665 0.015 76.056 0.013 85.663C0 125.221 0.013 164.777 0 204.336C0.002 209.072 0.993 213.268 2.993 216.886C5.049 220.606 8.17 223.716 12.394 226.164C32.633 237.897 100.558 276.842 114.12 284.852C123.241 290.239 132.147 290.431 141.335 285.122C175.405 265.431 209.521 245.822 243.607 226.152C247.831 223.705 250.952 220.593 253.008 216.876C255.005 213.258 255.998 209.062 256 204.325C256 204.325 256 125.231 255.987 85.672Z",
    fill: "#A9B9CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.101 5.13395C131.931 -0.160046 123.04 0.0329542 113.938 5.40295C100.395 13.39 32.59 52.237 12.385 63.94C4.064 68.757 0.015 76.129 0.013 85.711C0 125.166 0.013 164.62 0 204.076C0.002 208.8 0.991 212.985 2.988 216.593C5.041 220.304 8.157 223.406 12.374 225.847C17.003 228.528 24.133 232.635 32.533 237.467L219.625 50.375C193.447 35.301 167.262 20.239 141.101 5.13395Z",
    fill: "#7F8B99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.456 126.968L194.295 127.249C194.295 110.65 177.493 70 129.322 70C98.6311 70 57.3711 89.512 57.3711 145.61C57.3711 201.707 97.8181 220 129.322 220C180.339 220 192.532 184.698 192.532 164.748L154.525 162.575C154.525 162.575 155.542 185.65 129.119 185.65C104.729 185.65 100.659 155.772 100.659 145.61C100.659 130.163 106.152 105.366 129.119 105.366C152.087 105.366 154.456 126.968 154.456 126.968Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 288,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/c.773774198bd303d1f2b5b9c3043383da.svg";
export { ForwardRef as ReactComponent };